<template>
  <div class="w-full flex flex-col">
    <div class="w-full h-[80vh]">
      <iframe
        style="width: 100%; height: 100%; border: 0"
        allowfullscreen
        src="https://lookerstudio.google.com/embed/reporting/365f9fd0-bb4b-428e-9c26-fae12f20aa63/page/p_3z89qaahid"
        frameborder="0"
        sandbox="allow-storage-access-by-user-activation allow-scripts allow-same-origin allow-popups allow-popups-to-escape-sandbox"
      ></iframe>
    </div>
  </div>
</template>
<script setup></script>
